import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';
import { isDragging } from './isDragging';
import { SurfaceDragDropConfig } from 'owa-calendar-surface-dategrid/lib/store/schema/SurfaceDragDropConfig';
import { unlockSelectedItem } from './unlockSelectedItem';

/**
 * Ends a drag operation, this happens when the user either drops the item inside a
 * droppable or releases the mouse outside a droppable.
 * @param surfaceStore The surface store
 * @param dragDropConfig drag drop config
 */
export let endDragOperation = action('endDragOperation')(function endDragOperation(
    surfaceStore: CalendarSurfaceStore,
    dragDropConfig: SurfaceDragDropConfig
): void {
    let { dragDropState } = surfaceStore;
    unlockSelectedItem(surfaceStore);
    if (isDragging(dragDropState)) {
        dragDropConfig.onDragEnd(dragDropState.draggedItemModel);
        dragDropState.draggedItemModel = null;
        dragDropState.dragType = null;
        dragDropState.dragStartPosition = null;
        dragDropState.dragStartDate = null;
        dragDropState.dragOffset = null;
        dragDropState.dragPosition = null;
        dragDropState.helperItemModel = null;
    }
});
